module.exports = __webpack_public_path__ + "img/julongjiaye.2bb33e46.jpg";